/**
 * enumerator for the different types of how a toast message displays.
 */
export enum ToastTypes {
    error = 'error',
    info = 'info',
    success = 'success',
    warning = 'warning'
}
